import React from "react";
import { Container, Accordion, Row, Col } from "react-bootstrap";
const faqData = [
    {
        question:
            "When should QA be involved in a project?",
        answer:
            "QA is most effective when it starts early. Involving testing during development helps catch issues sooner and reduces problems closer to release.",
    },
    {
        question:
            "Can you test software that was developed by another team?",
        answer:
            "Yes. We can step into existing products, review current quality levels and support testing without needing to rebuild the development process.",
    },
    {
        question:
            "How do you decide what needs to be tested first?",
        answer:
            "We priorities based on business-critical workflows, user impact and the areas most likely to create release risk.",
    },
    {
        question:
            "Can QA continue after the initial release?",
        answer:
            "Yes. Ongoing QA helps reduce regressions, validate new features and keep software quality consistent across releases.",
    },
];

export default function FAQ() {
    return (
        <section className='padding-section-large faq-section'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">Frequently Asked <span className="text-gradient-1">Questions</span></h2>
                    </Col>
                </Row>
                <Accordion defaultActiveKey="0" flush>
                    {faqData.map((faq, index) => (
                        <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="faq-item"
                        >
                            <Accordion.Header>
                                {faq.question}
                            </Accordion.Header>
                            <Accordion.Body>
                                {faq.answer}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Container>
        </section>
    );
}